module.exports = __webpack_public_path__ + "media/คุกเข่าแล้วกราบแล้วให้พิชซ่าเราฟรีเดี๋ยวนี้.7cfd784d.mp3";